export function titleFilter(title: string): string {
  return title
    ? title
        .replace(/(<([^>]+)>)/gi, '')
        .replace(/\*([^*]+)\*/gi, '<b class="highlight">$1</b>')
    : '';
}
